/* unplugin-vue-components disabled */import { render } from "./PageVisitsTable.vue?vue&type=template&id=10e6e8ac"
import script from "./PageVisitsTable.vue?vue&type=script&lang=js"
export * from "./PageVisitsTable.vue?vue&type=script&lang=js"

import exportComponent from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__